import { ReactElement } from 'react';

import { Skeleton, TableCell, TableRow } from '@mui/material';

import { getRandomNumberInclusive } from '@/utils';

export const SkeletonRecentActivityTableRow = (): ReactElement => {
  return (
    <TableRow>
      {/* Date */}
      <TableCell>
        <Skeleton variant="rounded" width={30} height={21} />
      </TableCell>

      {/* Event Description */}
      <TableCell>
        <Skeleton
          variant="rounded"
          width={getRandomNumberInclusive(70, 100)}
          height={21}
        />
      </TableCell>

      {/* Type */}
      <TableCell>
        <Skeleton
          variant="rounded"
          width={getRandomNumberInclusive(20, 50)}
          height={21}
        />
      </TableCell>

      {/* Credits */}
      <TableCell>
        <Skeleton
          variant="rounded"
          width={getRandomNumberInclusive(70, 100)}
          height={21}
        />
      </TableCell>

      {/* Balance */}
      <TableCell>
        <Skeleton
          variant="rounded"
          width={getRandomNumberInclusive(70, 100)}
          height={21}
        />
      </TableCell>
    </TableRow>
  );
};
